export default "__VITE_ASSET__Dk8H4KWe__"